import { BankAccountType } from './constants/clients';
import { formatBankAccountDisplay } from './paymentMethodHelpers';

export const isBankAccountComplete = account => {
  if (!account) {
    return false;
  }
  return !!(
    account.bankAccountType !== null &&
    account.bankAccountNumber !== null &&
    account.bankName !== null &&
    account.bankCode !== null
  );
};

export const getBankAccountTypeTranslationKey = (type) => {
  switch (type) {
    case BankAccountType.SANTANDER_CHECKS:
      return 'ENUMS.ACCOUNT_TYPE.SANTANDER_CHECKS';
    case BankAccountType.DEBIT_CARD:
      return 'ENUMS.ACCOUNT_TYPE.DEBIT_CARD';
    case BankAccountType.CLABE:
      return 'ENUMS.ACCOUNT_TYPE.CLABE';
    default:
      return '';
  }
};

export const translateBankAccountType = (type, t) => {
  const key = getBankAccountTypeTranslationKey(type);
  return key ? t(key) : '';
};

export const mapBankAccountsToOptions = (bankAccounts, translateFn) => {
  return bankAccounts.map((account) => ({
    key: account.id,
    name: formatBankAccountDisplay(account, translateFn)
  }));
};

